<template>
  <div class="list-container">
    <div @click="playVideo" :class="!lesson.isLocked ? 'cursor-pointer' : ''" class="left">
      <template v-if="lesson.isLocked">
        <LockIcon />
      </template>
      <template v-else>
        <PlayNowIcon />
      </template>
      <p>{{lesson.name}}</p>
    </div>
    <div class="right"><p class="th-font-gray-3">{{lesson.videoDuration ? parseDuration(lesson.videoDuration) : 'Akan Datang' }}</p></div>
  </div>
</template>

<script>
import parseDuration from '@/helpers/videoDuration'
const LockIcon = () => import('@/components/Icon/Lock')
const PlayNowIcon = () => import('@/components/Icon/PlayNow')
export default {
  props: {
    lesson: {
      type: Object,
      required: true,
    },
  },
  components: {
    LockIcon,
    PlayNowIcon,
  },
  methods: {
    parseDuration,
    playVideo() {
      if (!this.lesson.isLocked) {
        const payload = {
          first: false,
          selectedLesson: this.lesson,
        }
        this.$emit('play-video', payload)
      }
    },
  },
}
</script>

<style lang="scss">
.list-container {
  margin-top: 25px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .left {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
  }
}
</style>
